import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as styles from './styles/styles.module.scss';
import * as formStyles from '../styles/styles.module.scss';
import * as baseStyles from '../../../styles/baseStyles.module.scss';
import * as buttonStyles from '../buttons/styles/styles.module.scss';
import { ProPageStrings, StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import {
  validatePaymentForm,
  getMonthByNumber,
  getYearByNumber,
  getTotalCost,
  getTotalBaseAnnualCost
} from '../../../utils/form_validaters/payment_form_helper';
import { hasErrors } from '../../../utils/form_validaters/user_form_helper';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import PlanTypeCardCollection from '../pro/PlanTypeCardCollection';
import CouponCode from '../CouponCode';

import Wrapper from '../Wrapper';
import CreditCardForm from '../CreditCardForm/CreditCardForm';

import FormButton from '../FormButton';

class UpdatePaymentForm extends Component {
  constructor(props) {
    super(props);
    const { billing_first_name, billing_last_name, cc_expiration_month, cc_expiration_year } = props.formData;

    this.state = {
      errors: {
        name: '',
        number: '',
        cvv: '',
        'cc-exp-month': '',
        'cc-exp-year': '',
        postalCode: ''
      },
      name: `${billing_first_name} ${billing_last_name}`,
      number: '',
      cvv: '',
      'cc-exp-month': getMonthByNumber(cc_expiration_month),
      'cc-exp-year': getYearByNumber(cc_expiration_year),
      postalCode: '',
      serverError: null,
      maxCodeSize: 3,
      submitting: false,
      activePlanType: props.planTypes && props.initialPlanType ? props.planTypes[props.initialPlanType] || 0 : null,
      verifiedCoupon: this.props.coupon,
      couponCode: this.props.coupon ? this.props.coupon.code : null,
      isCouponApplied: false,
      couponError: '',
      isCouponInputExpanded: false
    };
  }

  static TEXT = {
    ...ProPageStrings.paymentText,
    creditCardForm: ProPageStrings.creditCardForm,
    submitText: StringConstantsMixin.strings.SUBMIT,
    cancelText: StringConstantsMixin.strings.CANCEL,
    headText: ProPageStrings.paymentText.creditCard,
    planTypeText: ProPageStrings.planTypeText
  };

  static CANCEL_URL = '/my/profile/edit';

  static ANNUAL_PLAN = 'annual';

  static THREE_YEAR_PLAN = 'threeYr';

  static PLANS = ['annual', 'threeYr'];

  static GIFT_CARD = 'GiftCard';

  componentDidMount() {
    if (this.state.verifiedCoupon && this.props.reactivation) {
      this.setState({ isCouponApplied: true, isCouponInputExpanded: true, isCouponInputShown: true, submitting: false });
    }
  }

  handleTypeClick = activePlanType => {
    this.setState({ activePlanType }, this.handleRemoveCoupon);
  };

  handleCreditCardFormChange = event => {
    const { name, value } = event.target;
    const monthAndYear = this.getMonthAndYear();
    const payload = validatePaymentForm(name, value, monthAndYear, this.state.errors, UpdatePaymentForm.TEXT.creditCardForm, this.state.maxCodeSize);
    this.setState({ ...payload });
  };

  handlePaymentEditSuccess = data => {
    window.location.href = LanguageSupportUtil.wrapUrlSafe(data.redirectUrl, this.props.locale);
  };

  handleRemoveCoupon = () => {
    this.setState({
      isCouponInputExpanded: false,
      couponCode: null,
      isCouponApplied: false,
      verifiedCoupon: null
    });
  };

  handleCouponCodeChange = event => {
    const { value } = event.target;
    this.setState({ couponCode: value, couponError: '' });
  };

  handleShowCouponCodeInput = () => {
    this.setState({ isCouponInputExpanded: true });
  };

  handleApplyCoupon = () => {
    this.handleCouponVerification(this.state.couponCode);
  };

  handlePaymentFormError = err => {
    let { errors, serverError } = this.state;

    let errorObj;
    try {
      errorObj = JSON.parse(err.responseText).errors;
    } catch (e) {
      errorObj = false;
    }

    if (errorObj) {
      if (errorObj.base) {
        serverError = typeof errorObj.base[0] === 'string' ? errorObj.base[0] : UpdatePaymentForm.TEXT.serverError;
      }
      if (errorObj.cc_number) {
        errors.number = errorObj.cc_number[0];
      }
      if (errorObj.cc_expiration_month) {
        errors['cc-exp-month'] = errorObj.cc_expiration_month[0];
      }
      if (errorObj.cc_expiration_year) {
        errors['cc-exp-year'] = errorObj.cc_expiration_year[0];
      }
      if (errorObj.cc_csc) {
        errors.cvv = errorObj.cc_csc[0];
      }
    } else {
      serverError = UpdatePaymentForm.TEXT.serverError;
    }
    this.setState({ errors, serverError, submitting: false });
  };

  // gets
  getMonthAndYear() {
    return {
      'cc-exp-month': this.state['cc-exp-month'],
      'cc-exp-year': this.state['cc-exp-year']
    };
  }

  getFootText() {
    const months = this.props.planTypes.find(planType => planType.planCode === this.state.activePlanType).numberOfMonths;
    const totalCost = getTotalCost(this.props.planTypes, this.state.activePlanType, this.state.verifiedCoupon, this.props.currencyCode);
    const baseAnnualCost = getTotalBaseAnnualCost(this.props.planTypes, this.state.activePlanType, this.props.currencyCode);
    const { footText } = UpdatePaymentForm.TEXT;

    if (this.props.activePlanType === UpdatePaymentForm.THREE_YEAR_PLAN) {
      return UpdatePaymentForm.TEXT.threeYearFootText;
    }

    return this.state.isCouponApplied
      ? `${footText.lead} ${totalCost} ${footText.mid} ${months} ${footText.discountMid} ${baseAnnualCost} ${footText.discountTail}`
      : `${footText.lead} ${totalCost} ${footText.mid} ${months} ${footText.tail}`;
  }

  getHeaderAndFooterText() {
    let text = UpdatePaymentForm.TEXT;
    let footText = '';

    if (this.props.reactivation) {
      text = { ...text, headText: UpdatePaymentForm.TEXT.planTypeText.headText };

      if (this.state.activePlanType === UpdatePaymentForm.ANNUAL_PLAN) {
        footText = this.getFootText();
      } else {
        footText = UpdatePaymentForm.TEXT.threeYearFootText;
      }
    }

    return { text, footText };
  }

  getSubmissionData() {
    let data = {
      user: {
        cc_number: this.state.number,
        cc_expiration_month: this.state['cc-exp-month'] ? this.state['cc-exp-month'].value : null,
        cc_expiration_year: this.state['cc-exp-year'] ? this.state['cc-exp-year'].value : null,
        cc_csc: this.state.cvv,
        zip: this.state.postalCode,
        authenticity_token: this.props.authenticityToken
      }
    };

    // requires additional params if currently in the reactivation flow
    if (this.props.reactivation) {
      data = {
        ...data,
        plan_type: this.state.activePlanType,
        user: {
          ...data.user,
          user_entered_coupon_code: this.state.verifiedCoupon ? this.state.verifiedCoupon.code : null,
          reactivating: true
        }
      };
    }

    return data;
  }

  clearErrors() {
    this.setState({
      errors: {
        name: '',
        number: '',
        cvv: '',
        'cc-exp-month': '',
        'cc-exp-year': '',
        postalCode: ''
      }
    });
  }

  noGiftCard() {
    if (!this.props.reactivation || !this.state.verifiedCoupon) {
      return true;
    }

    return this.state.verifiedCoupon.type !== UpdatePaymentForm.GIFT_CARD;
  }

  failedFormValidation() {
    let validation;
    let validationErrors = { ...this.state.errors };
    const monthAndYear = this.getMonthAndYear();

    for (const name in this.state.errors) {
      validation = validatePaymentForm(
        name,
        this.state[name],
        monthAndYear,
        this.state.errors,
        UpdatePaymentForm.TEXT.creditCardForm,
        this.state.maxCodeSize
      );
      validationErrors = { ...validationErrors, ...validation.errors };
    }
    this.setState({ errors: validationErrors });
    return hasErrors(validationErrors);
  }

  submitCreditCardForm = e => {
    e.preventDefault();
    if (this.state.submitting) {
      return;
    }

    this.setState({ submitting: true });

    if (this.noGiftCard()) {
      if (this.failedFormValidation()) {
        this.setState({ submitting: false });
        return;
      }
    }

    this.clearErrors();
    const submissionData = this.getSubmissionData();

    ServerCommunicationUtil.putApiEndpoint(
      this.props.updateBillingUrl,
      submissionData,
      this.handlePaymentEditSuccess,
      this.handlePaymentFormError,
      () => {},
      { 'X-Language-Locale': this.props.locale }
    );
  };

  handleCouponVerification = couponCode => {
    if (this.state.submitting) {
      return;
    }

    this.setState({ submitting: true });
    const payload = {
      coupon_code: couponCode
    };
    ServerCommunicationUtil.postApiEndpoint(
      '/api/alltrails/coupons/verify',
      payload,
      data => {
        this.setState({ verifiedCoupon: data[0], isCouponApplied: true, submitting: false });
      },
      err => {
        this.setState({
          isCouponApplied: false,
          couponError: UpdatePaymentForm.TEXT.creditCardForm.couponCode.validation.generic,
          submitting: false
        });
      },
      () => {}
    );
  };

  // renders
  renderServerError() {
    return <div className={this.state.serverError ? styles.serverError : ''}>{this.state.serverError}</div>;
  }

  renderPlanOptions() {
    if (!this.props.reactivation) {
      return;
    }

    return (
      <>
        <PlanTypeCardCollection
          planTypes={this.props.planTypes}
          handler={this.handleTypeClick}
          activePlanType={this.state.activePlanType}
          currencyCode={this.props.currencyCode}
          verifiedCoupon={this.state.verifiedCoupon}
          isCouponApplied={this.state.isCouponApplied}
          isSuccess={this.state.isCouponApplied}
        />
        <div className={styles.divider} />
      </>
    );
  }

  renderCouponCodeInput() {
    if (!this.props.reactivation) {
      return;
    }

    return (
      <CouponCode
        text={UpdatePaymentForm.TEXT}
        expanded={this.state.isCouponInputExpanded}
        removeHandler={this.handleRemoveCoupon}
        showHandler={this.handleShowCouponCodeInput}
        changeHandler={this.handleCouponCodeChange}
        applyHandler={this.handleApplyCoupon}
        isSuccess={this.state.isCouponApplied}
        errorMessage={this.state.couponError}
        value={this.state.couponCode}
      />
    );
  }

  renderCreditCardForm() {
    return (
      <>
        {this.props.reactivation && <div className={styles.billingText}>{UpdatePaymentForm.TEXT.enterBillingInformation}</div>}
        <form onSubmit={this.submitCreditCardForm}>
          <CreditCardForm
            text={UpdatePaymentForm.TEXT.creditCardForm}
            errors={this.state.errors}
            changeHandler={this.handleCreditCardFormChange}
            name={this.state.name}
            number={this.state.number}
            month={this.state['cc-exp-month']}
            year={this.state['cc-exp-year']}
            cvv={this.state.cvv}
            postalCode={this.state.postalCode}
            submitHandler={this.submitCreditCardForm}
          />
          {this.renderCouponCodeInput()}
          {this.renderServerError()}
          <div>
            <FormButton value={UpdatePaymentForm.TEXT.submitText} disabled={this.state.submitting} />
            {!this.props.reactivation && (
              <a className={buttonStyles.text} href={UpdatePaymentForm.CANCEL_URL}>
                {UpdatePaymentForm.TEXT.cancelText}
              </a>
            )}
          </div>
        </form>
      </>
    );
  }

  render() {
    const { text, footText } = this.getHeaderAndFooterText();

    return (
      <Wrapper text={text} foot={<>{footText}</>} extraContainerClass={`${styles.wrapperContainerClasses}`}>
        {this.renderPlanOptions()}
        <div className={baseStyles.section}>
          <div>{this.renderCreditCardForm()}</div>
        </div>
      </Wrapper>
    );
  }
}

UpdatePaymentForm.defaultProps = {};

UpdatePaymentForm.propTypes = {
  locale: PropTypes.string,
  recurlyPublicKey: PropTypes.string,
  updateBillingUrl: PropTypes.string,
  initialPlanType: PropTypes.string,
  formAuthenticityToken: PropTypes.string,
  planTypes: PropTypes.arrayOf(
    PropTypes.shape({
      planCode: PropTypes.string,
      priceMonth: PropTypes.string,
      priceTotal: PropTypes.string,
      numberOfMonths: PropTypes.string,
      showDiscount: PropTypes.bool,
      allowCoupon: PropTypes.bool
    })
  ),
  formData: PropTypes.shape({
    billing_first_name: PropTypes.string,
    billing_last_name: PropTypes.string,
    cc_expiration_month: PropTypes.number,
    cc_expiration_year: PropTypes.number
  })
};

export default UpdatePaymentForm;
